export default function MDXRenderer() {
  return (
    <></>
  )
}